export const GREEN_COLOR = '#416036';
